
/**
 ** This function takes workflow data and configuration info 
 * @param {*} selectedData 
 * @param {*} configuration 
 * @param {*} stephistory
 * @returns validation required or not
 */
const determineRequired = async (selectedData, config, step_history,assign_approval_to,assigned_dynamic_step) => {
    let required = false;
  
    const currentStepConfig = config.find(item => item.step === selectedData.active_step);
    if (!currentStepConfig) return required;
  
    const nextStep = currentStepConfig.next_step;
    if (!nextStep) return required;

    const nextStepConfig = config.find(item => item.step === nextStep);
    if (!nextStepConfig) return required;
  
    if (nextStepConfig.module_name === 'approval' || nextStepConfig?.is_conditional === true) {
      required = false;
      return required;
    }
  
    const stepHistorySteps = step_history?.map(step => step.active_step);
    for (let step = selectedData.active_step + 1; step <= nextStep; step++) {
        if (stepHistorySteps.includes(step)) {
            required = true;
            break;
        }
    }
    if(assign_approval_to && assigned_dynamic_step){
      required = true;
    }
    return required;
  };
  
  export default determineRequired;
  